import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CBody1,
    CCard,
    CCardContent,
    CContainer,
    CH3
} from "../../components";
import {useNavigate} from "react-router-dom";

export const SubmitMessage = observer(
    function SubmitMessage() {
        const navigate = useNavigate();

        return (
            <>
                <main style={{minHeight: '100vh'}}>
                    <CContainer
                        style={{display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
                        <CCard>
                            <CCardContent sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                                <CH3 sx={{
                                    mb: 2,
                                    fontWeight: '900',
                                    color: '#424242'
                                }}>
                                    Done
                                </CH3>
                                <CBody1 sx={{
                                    mb: 2,
                                    color: '#424242'
                                }}>
                                    Your business is submitted successfully.

                                    Please wait for our operators to reach out.
                                </CBody1>
                                <CBody1 sx={{
                                    mb: 4,
                                    color: '#424242'
                                }}>
                                    Contact us for more information.
                                </CBody1>
                            </CCardContent>
                        </CCard>
                    </CContainer>
                </main>
            </>
        );
    }
)
